import React from 'react';
import PropTypes from 'prop-types';

export const Shield = ({ width, height, ...props }) => (
  <svg
    data-icon='shield'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 22c-2.317-.583-4.23-1.913-5.737-3.988C4.754 15.938 4 13.633 4 11.1V5l8-3 8 3v6.1c0 2.533-.754 4.838-2.262 6.912C16.229 20.087 14.317 21.418 12 22Zm0-2.1c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.375l-6-2.25-6 2.25V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z'
    />
  </svg>
);

Shield.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Shield.defaultProps = {
  width: 24,
  height: 24,
};
